import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dishenda_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const path = window.location.pathname;
    if (err.response?.status === 403 && err.response?.data?.detail === "account_sospeso") {
      if (!path.startsWith("/sospeso")) {
        window.location.href = "/sospeso";
      }
    }
    if (err.response?.status === 401 && !path.startsWith("/login") && !path.startsWith("/s/") && !path.startsWith("/p/") && !path.startsWith("/prenotazione/") && !path.startsWith("/fidelity/") && !path.startsWith("/fidelity-join") && !path.startsWith("/richiedi-info") && !path.startsWith("/vetrina") && !path.startsWith("/locali")) {
      localStorage.removeItem("dishenda_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Errore imprevisto";
}

export const STATUS = {
  da_confermare: { label: "Da confermare", bg: "bg-amber-100", text: "text-amber-800", border: "border-amber-300" },
  confermata: { label: "Confermata", bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-300" },
  in: { label: "IN", bg: "bg-blue-100", text: "text-blue-800", border: "border-blue-300" },
  out: { label: "OUT", bg: "bg-zinc-100", text: "text-zinc-600", border: "border-zinc-300" },
  no_show: { label: "No-show", bg: "bg-rose-100", text: "text-rose-800", border: "border-rose-300" },
  cancellata: { label: "Cancellata", bg: "bg-rose-100", text: "text-rose-800", border: "border-rose-300" },
  rifiutata: { label: "Rifiutata", bg: "bg-rose-100", text: "text-rose-800", border: "border-rose-300" },
  lista_attesa: { label: "Lista d'attesa", bg: "bg-sky-100", text: "text-sky-800", border: "border-sky-300" },
};

export const CHANNELS = ["telefono", "walk-in", "sito", "google", "thefork", "whatsapp", "landing_evento", "landing_standard", "modulo_web", "altro"];

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export default api;
